module.exports = __webpack_public_path__ + "img/headBg-lazy3.d58dfdb1.jpg";